import { findAndReplace } from '../../../node_modules/mdast-util-find-and-replace/lib/index.js';

const RE_SCHEME_OR_WWW = /(?:https?:\/\/|www\.)/.source;
const RE_USERINFO = /([a-z0-9.:_~-]+@)?/.source;
const RE_DOMAIN = /(?:[a-zA-Z0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF-]{1,256}\.)+[a-z]{2,32}/.source;
const RE_IPV4 = /(?:(?:25[0-5]|(?:2[0-4]|1\d|[1-9]|)\d)\.?\b){4}/.source;
const RE_URL = new RegExp(`${RE_SCHEME_OR_WWW}${RE_USERINFO}(?:${RE_DOMAIN}|${RE_IPV4})(?::[0-9]{2,5})?\\b(?:[/?][-a-zA-Z0-9@:%_\\+.~#?&\\/\\/=]*)?(?<![&?.])`, "gi");
function rehypeAutoLinks(options = {
  enabled: false
}) {
  return (tree) => {
    if (!options.enabled) {
      return;
    }
    findAndReplace(tree, [
      [
        RE_URL,
        (url) => ({
          type: "link",
          url: /^https?:\/\//.test(url) ? url : `https://${url}`,
          children: [
            {
              type: "text",
              value: url
            }
          ]
        })
      ]
    ]);
  };
}

export { rehypeAutoLinks as default };
//# sourceMappingURL=rehypeAutoLinks.js.map
